<template>
    <shed-add-form></shed-add-form>
</template>


<script>

    import ShedAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            ShedAddForm,
        },

    }
</script>

